import { render, staticRenderFns } from "./batchDetail.vue?vue&type=template&id=6be969ba&scoped=true&"
import script from "./batchDetail.vue?vue&type=script&lang=js&"
export * from "./batchDetail.vue?vue&type=script&lang=js&"
import style0 from "./batchDetail.vue?vue&type=style&index=0&id=6be969ba&prod&scoped=true&lang=less&"
import style1 from "./batchDetail.vue?vue&type=style&index=1&id=6be969ba&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be969ba",
  null
  
)

export default component.exports